


















import StepperFlowMixin from '@/mixins/donationStepperFlowMixin';
import DonationStepFlowV1Component from './DonationStepFlowV1Component.vue';
import DonationStepFlowV2Component from './DonationStepFlowV2Component.vue';
import { DonationStepFlowVersion } from '@/enums/donationStepFlowVersion';

export default {
  name: 'DonationFlowWrapper',
  components: {
    DonationStepFlowV1Component,
    DonationStepFlowV2Component
  },
  mixins: [StepperFlowMixin],
  props: {
    definedStep: [String, Number],
    multipleDonationTypes: Boolean,
    requestHasExternalAgent: Boolean,
    requestHasOnlyOneCase: Boolean,
  },
  computed: {
    useUpdatedDonationFlow(): boolean {
      return this.donationStepFlowVersion === DonationStepFlowVersion.V2;
    }
  }
};
